module.exports = __webpack_public_path__ + "img/security.18f4cedb.svg";